import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import styles from '../TermsOfUse/TermsOfUse.module.css';
import SEO from '../../Components/SEO/SEO';
import { STATIC_PAGE_META } from '../../seo/pageMeta';

const SECTIONS = [
  { key: 'section1' },
  { key: 'section2' },
];

const AUP = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <SEO {...STATIC_PAGE_META['aup']} />
      <div className={styles.container}>
        <Link to="/" className={styles.backButton} aria-label={t('legal.back')}>
          <FiArrowLeft /> {t('legal.back')}
        </Link>
        <h1 className={styles.title}>{t('legal.aup.title')}</h1>
        <p className={styles.lastUpdated}>{t('legal.aup.lastUpdated')}</p>
        {SECTIONS.map(({ key }) => (
          <section key={key} className={styles.section}>
            <h2 className={styles.sectionTitle}>{t(`legal.aup.${key}Title`)}</h2>
            <p className={styles.sectionBody}>{t(`legal.aup.${key}Body`)}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default AUP;
